import React, {useState, useEffect} from "react";
import {useTitleFromComponent, useDataWithRoute} from "../../../utils/hooks";
import {useVsiAppContext} from "../../../stores/VsiApp";
import {VsiBubble, VsiH4} from "../../../styled/App.styled";
import {Card} from "reactstrap";
import AtAGlance from "../../../components/AtAGlance";
import VerticalBarChart from "../../../components/VerticalBarChart";

const costsAag = [
    {
        field: "current_cost",
        title: "Cost Per Month",
        mobile: true,
        dollarSign: true
    },
    {
        field: "optimized_cost",
        title: "Optimized Cost Per Month",
        mobile: true,
        dollarSign: true
    },
    {
        field: "potential_savings",
        title: "Potential Savings",
        mobile: true,
        dollarSign: true
    },
    {
        field: "cost_per_vm",
        title: "$ / VM",
        mobile: true,
        dollarSign: true
    },
    {
        field: "cost_per_cpu",
        title: "$ / CPU",
        mobile: true,
        dollarSign: true
    },
    {
        field: "cost_per_gb_memory",
        title: "$ / GB Memory",
        mobile: true,
        dollarSign: true
    },
    {
        field: "cost_per_gb_storage",
        title: "$ / GB Storage",
        mobile: true,
        dollarSign: true
    },
];

const sortingArr = ['Current Cost', 'Optimized Cost', 'Savings'];

export default function CloudCostReport({context, title}) {
    useTitleFromComponent(`${context} / ${title}`);
    const { theme, client, periodId } = useVsiAppContext();

    const [data] = useDataWithRoute(`/api/v6/report/enterprise_cloud_cost_proc?client_id=${client.clientId}&period_id=${periodId}`);
    
    const [atAGlanceData, setAtAGlanceData] = useState({});
    const [tagCats, setTagCats] = useState([]);
    const [graphData, setGraphData] = useState({
        categories: [],
        series: []
    });

    const barChartBuilder = (data) => {
        var currentCost = [];
        var optimizedCost = [];
        var savings = [];

        data.forEach(datum => {
            if (datum.current_cost) {
                currentCost.push(datum)
            };
            if (datum.optimized_cost) {
                optimizedCost.push(datum)
            };
            if (datum.potential_savings) {
                savings.push(datum)
            };
        });

        var allCats = [];

        var tags = data.map(datum => {
            return datum.tag
        });

        allCats = tags.filter((classType, index) => {
            return tags.indexOf(classType) === index;
        });
        
        setTagCats(allCats);

        // Current Cost
        let currentCostNewData = [];
        for (let i = 0; i < allCats.length; i++) {
            let total = 0;
            for (let y = 0; y < currentCost.length; y++) {
                if (allCats[i] === currentCost[y].tag) {
                    total = total + currentCost[y].current_cost;
                };
            };
            currentCostNewData.push(parseFloat((total).toFixed(2)));
        };

        // Optimized Cost
        let optimizedCostNewData = [];
        for (let i = 0; i < allCats.length; i++) {
            let total = 0;
            for (let y = 0; y < optimizedCost.length; y++) {
                if (allCats[i] === optimizedCost[y].tag) {
                    total = total + optimizedCost[y].optimized_cost;
                };
            };

            optimizedCostNewData.push(parseFloat((total).toFixed(2)));
        };

        // Potential Savings
        let savingsNewData = [];
        for (let i = 0; i < allCats.length; i++) {
            let total = 0;
            for (let y = 0; y < savings.length; y++) {
                if (allCats[i] === savings[y].tag) {
                    total = total + savings[y].potential_savings;
                };
            };
            savingsNewData.push(parseFloat((total).toFixed(2)));
        };

        var finalArray = [currentCostNewData, optimizedCostNewData, savingsNewData];

        var chartInfo = [];
        for (let i = 0; i < sortingArr.length; i++) {
            chartInfo.push({
                name: sortingArr[i],
                data: finalArray[i]
            });
        };
        setGraphData(chartInfo);
    };

    useEffect(() => {
        if(data?.recordsets?.[0]?.length) {
            setAtAGlanceData(data.recordsets[0]?.[0])
        }
        if(data?.recordsets?.[1]?.length) {
            barChartBuilder(data.recordsets[1]);
        }
    }, [data]);

    return <Card className={`report-card p-2 nav-card-${theme}`}>
        <VsiH4>Cloud Cost Report</VsiH4>
        <VsiBubble>
            <AtAGlance config={costsAag} data={atAGlanceData} size={"lg"}/>
        </VsiBubble>
        <VsiBubble autobotName='ColumnChart'>
            <VerticalBarChart
                categories={tagCats}
                height={600}
                colors={["#ff8d02", '#099c9d', '#B0EA3B']}
                includeLegend={true}
                series={graphData}
            />
        </VsiBubble>
    </Card>
}
